import { render } from "./pointList.vue?vue&type=template&id=58361288&scoped=true"
import script from "./pointList.vue?vue&type=script&lang=js"
export * from "./pointList.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=58361288&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&id=58361288&scoped=true&lang=css"
import "./pointList.vue?vue&type=style&index=2&id=58361288&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58361288"]])

export default __exports__